import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-cell-array',
  templateUrl: './table-cell-array.component.html',
  styleUrls: ['./table-cell-array.component.scss'],
})
export class TableCellArrayComponent implements OnInit {
  @Input() public data: string[];
  @Input() public textOnEmpty = '';
  public toolTipText = '';

  ngOnInit(): void {
    if (this.data.length > 1) {
      this.toolTipText = this.data.slice(1).join(', ');
    }
  }
}
